import {
  DISABLE_365_INTEGRATION_REQUEST_ASYNC,
  DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC,
  STATUS_365_REQUEST_ASYNC,
  STATUS_POWERSHELL_REQUEST_ASYNC,
} from './constants'

export const get365Status = () => ({ type: STATUS_365_REQUEST_ASYNC.INITIATE })
export const getStatus365Success = (data) => ({
  type: STATUS_365_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getStatus365Error = (error) => ({
  type: STATUS_365_REQUEST_ASYNC.ERROR,
  error,
})

export const disable365Integration = () => ({
  type: DISABLE_365_INTEGRATION_REQUEST_ASYNC.INITIATE,
})
export const disable365IntegrationSuccess = (data) => ({
  type: DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const disable365IntegrationError = (error) => ({
  type: DISABLE_365_INTEGRATION_REQUEST_ASYNC.ERROR,
  error,
})

export const getPowershellStatus = () => ({ type: STATUS_POWERSHELL_REQUEST_ASYNC.INITIATE })
export const getStatusPowershellSuccess = (data) => ({
  type: STATUS_POWERSHELL_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getStatusPowershellError = (error) => ({
  type: STATUS_POWERSHELL_REQUEST_ASYNC.ERROR,
  error,
})

export const disablePowershellIntegration = () => ({
  type: DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.INITIATE,
})
export const disablePowershellIntegrationSuccess = (data) => ({
  type: DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const disablePowershellIntegrationError = (error) => ({
  type: DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getPowershellStatus,
  disablePowershellIntegration,
  get365Status,
  disable365Integration,
}
